import { useMemo } from 'react'
import { ALL_FIELD_TYPES } from '@carto/kepler.gl/constants'
import { AggregationTypes } from '@carto/react-core'
import { MapDatasetEnriched, RangeWidget } from 'features/builder'
import { KeplerFieldType } from 'features/builder/types'

const availableFieldTypesForColumn: KeplerFieldType[] = [ALL_FIELD_TYPES.integer, ALL_FIELD_TYPES.real]

export function isRangeWidgetValid(widget: RangeWidget, { source }: { source: MapDatasetEnriched }): boolean {
  const columnType = source.fields?.find((f) => f.id === widget.column)?.type as KeplerFieldType

  return Boolean(widget.column && columnType && availableFieldTypesForColumn.includes(columnType))
}

function useWidgetRangeModel({ source }) {
  const validateWidget = (widget: RangeWidget) => {
    const columnType = source.fields.find((f) => f.id === widget.column)?.type

    if (!availableFieldTypesForColumn.includes(columnType)) {
      widget.column = ''
      widget.spatialIndexAggregation = undefined
      widget.min = undefined
      widget.max = undefined
    }

    widget.operation = AggregationTypes.COUNT

    if (!widget.column) {
      widget.isValid = false
    } else {
      widget.isValid = true
    }
  }

  const isWidgetAvailable = useMemo(() => {
    return source.fields.some((f) => availableFieldTypesForColumn.includes(f.type))
  }, [source])

  return {
    validateWidget,
    isWidgetAvailable,
    availableFieldTypesForColumn
  }
}

export default useWidgetRangeModel
